// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WDW COLOR CODE */
/* AULANI COLOR CODE */
/**
 * variables.scss
 * Contains the sitewide variables
 */
/**
 * Breakpoints variables
 */
/**
 * Colors variables
 */
/**
 * z-index variables
 */
/**
 * function.scss
 * Contains the sitewide functions
 */
/**
 * mixins.scss
 * Contains the sitewide mixins
 */
/**
 * mixins.scss
 * Contains the sitewide mixins
 */
/**
 * global.scss
 * Contains the sitewide global styles
 */
* {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
*:before, *:after {
  box-sizing: border-box;
}
*:focus {
  outline: 1px dotted #000;
}

html,
body {
  margin: 0;
  min-height: 100vh;
}

body {
  width: 100%;
}

img {
  width: 100%;
}

h1,
h2,
h3,
h4,
h5 {
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
span,
a,
li,
p,
input,
textarea {
  font-family: inherit;
}

.clearfix {
  zoom: 1;
}
.clearfix:after {
  clear: both;
}
.clearfix:after, .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

/**
 * reset.scss
 * Contains the sitewide css reset
 */
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
abbr,
address,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
samp,
small,
strong,
sub,
sup,
var,
b,
i,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
time,
mark,
audio,
video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
img,
menu,
nav,
section {
  display: block;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}
blockquote :before,
blockquote :after,
q :before,
q :after {
  content: none;
}

a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}

input,
select {
  vertical-align: middle;
}

address {
  font-style: normal;
}

input::-ms-clear {
  display: none;
}

button {
  background: none;
  border: 0;
  padding: 0;
}

.aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
.aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}

.vehicle-registration {
  padding: 32px 0 0 36px;
  --link: \$aulani-link-color;
}
.vehicle-registration .border-section {
  height: 1px;
  border-bottom: thin solid #918F8C;
  background-image: none;
  margin: 32px 0 0;
  width: 100%;
}
.vehicle-registration .border-section.hide-broder {
  border-bottom: none;
  height: 0;
}
.vehicle-registration .left-section .vehicle-heading {
  display: flex;
}
.vehicle-registration .left-section .vehicle-heading h3 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: 0;
  font-family: "InspireTWDCHeavy";
  color: #382613;
  padding-left: 12px;
}
.vehicle-registration .left-section .vehicle-heading img.ground-car {
  width: 27px;
  height: 24px;
  font-size: 21px;
  color: #382613;
}
.vehicle-registration .left-section .content {
  width: 600px;
  margin-left: 40px;
  padding: 16px 0 16px 0;
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
.vehicle-registration .left-section .content span.text {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
.vehicle-registration .left-section .content a {
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #B73C00;
}
.vehicle-registration .left-section .counter {
  margin-left: 40px;
  display: flex;
}
.vehicle-registration .left-section .counter .que-text {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}

.number-stepper {
  display: flex;
  width: 145px;
  justify-content: space-between;
  align-items: center;
  margin-left: 28px;
  margin-top: -10px;
}
.number-stepper .number-stepper-button {
  width: 32px;
  height: 32px;
  gap: 0px;
  opacity: 0px;
  border: 1px solid #D04901;
  border-radius: 50%;
  color: #D04901;
  outline: none;
  font-size: x-large;
  cursor: pointer;
}
.number-stepper .number-stepper-button:hover, .number-stepper .number-stepper-button:active {
  border: 1px solid #D04901;
  color: 1px solid #D04901;
}
.number-stepper .number-stepper-button:disabled {
  border: 1px solid #C2BFB8;
  color: #C2BFB8;
}
.number-stepper .count-number {
  font-size: 40px;
  line-height: 45px;
  font-weight: 300;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman" !important;
  color: #382613 !important;
  min-width: 80px;
  text-align: center;
}
.number-stepper .negative {
  padding-bottom: 5px;
}

@media only screen and (max-width: 767px) {
  .vehicle-registration {
    padding: 32px 20px 0 20px;
  }
  .vehicle-registration .border-section {
    margin: 32px 0 0;
    width: 100%;
  }
  .vehicle-registration .left-section {
    width: 100%;
  }
  .vehicle-registration .left-section .vehicle-heading img.ground-car {
    margin-left: 0px;
    top: 0;
  }
  .vehicle-registration .left-section .vehicle-heading h3 {
    font-size: 18px;
    line-height: 27px;
    font-weight: 600;
    letter-spacing: 0;
    padding-left: 12px;
  }
  .vehicle-registration .left-section .content {
    width: 100%;
    margin-left: 0;
    padding: 12px 0 24px 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  .vehicle-registration .left-section .content span.text {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  .vehicle-registration .left-section .content a {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
  }
  .vehicle-registration .left-section .counter {
    padding-left: 0;
    margin-left: 0;
  }
  .vehicle-registration .left-section .counter .que-text {
    width: 50%;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  .vehicle-registration .left-section .counter .number-stepper {
    margin-left: 21px;
  }
  .vehicle-registration .right-section {
    margin-top: 16px;
  }
}
.vehicle-registration-mod-flow {
  padding: 32px 0 0 40px;
  --link: \$aulani-link-color;
}
.vehicle-registration-mod-flow .border-section {
  height: 1px;
  border-bottom: thin solid #918F8C;
  background-image: none;
  margin: 30px 0 0 -30px;
  width: calc(100% + 30px);
}
.vehicle-registration-mod-flow .left-section {
  width: 70%;
  float: left;
}
.vehicle-registration-mod-flow .left-section .vehicle-heading {
  display: flex;
}
.vehicle-registration-mod-flow .left-section .vehicle-heading h3 {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: 0;
  font-family: "InspireTWDCHeavy";
  color: #382613;
  padding-left: 12px;
}
.vehicle-registration-mod-flow .left-section .vehicle-heading img.ground-car {
  width: 24px;
  height: 24px;
  font-size: 21px;
  color: #382613;
  margin-left: 0;
  margin-top: 3px;
}
.vehicle-registration-mod-flow .left-section .content {
  padding: 10px 0 0 40px;
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
.vehicle-registration-mod-flow .left-section .content p.text {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
.vehicle-registration-mod-flow .left-section .learn-more-info {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
  margin-top: 10px;
}
.vehicle-registration-mod-flow .left-section .learn-more-info span {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
.vehicle-registration-mod-flow .left-section .learn-more-info a {
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #B73C00;
}
.vehicle-registration-mod-flow .left-section .counter {
  display: flex;
}
.vehicle-registration-mod-flow .left-section .counter .que-text {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
.vehicle-registration-mod-flow .left-section .number-stepper {
  margin-left: 24px;
  margin-top: -10px;
}
.vehicle-registration-mod-flow .right-section {
  float: right;
}
.vehicle-registration-mod-flow .right-section .section-edit {
  font-family: "InspireTWDCMedium";
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #B73C00;
  font-weight: 600;
  cursor: pointer;
}
.vehicle-registration-mod-flow .right-section .section-edit:hover {
  color: #7C3813;
}
.vehicle-registration-mod-flow .right-section .section-edit:focus {
  color: #B73C00;
  outline: 2px solid #B73C00;
  outline-offset: 4px;
}

@media only screen and (max-width: 767px) {
  .vehicle-registration-mod-flow {
    padding: 16px 0 0 35px;
  }
  .vehicle-registration-mod-flow .left-section.counter-section {
    width: 100%;
  }
  .vehicle-registration-mod-flow .left-section .number-stepper {
    margin-left: 0;
    width: auto;
  }
  .vehicle-registration-mod-flow .left-section .number-stepper .count-number {
    min-width: 40px;
  }
  .vehicle-registration-mod-flow .left-section .vehicle-heading {
    display: flex;
  }
  .vehicle-registration-mod-flow .left-section .vehicle-heading h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
    padding-left: 17px;
  }
  .vehicle-registration-mod-flow .left-section .vehicle-heading img.ground-car {
    width: 20px;
    height: 20px;
    font-size: 21px;
    color: #382613;
    margin-left: 0;
    margin-top: 1px;
  }
  .vehicle-registration-mod-flow .left-section .content {
    padding: 8px 0 0 40px;
  }
  .vehicle-registration-mod-flow .left-section .counter {
    display: flex;
  }
  .vehicle-registration-mod-flow .left-section .counter .que-text {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  .vehicle-registration-mod-flow .left-section .learn-more-info {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  .vehicle-registration-mod-flow .left-section .learn-more-info a {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
    color: #B73C00;
  }
  .vehicle-registration-mod-flow .right-section {
    float: right;
    margin-top: 30px;
  }
  .vehicle-registration-mod-flow .right-section .section-edit {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/app/vehicle-registration/vehicle-registration.component.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/assets/style/base/font.scss"],"names":[],"mappings":"AAAA,mBAAA;AAkBA,sBAAA;AClBA;;;EAAA;AAKA;;EAAA;AAgBA;;EAAA;AAQA;;EAAA;AC7BA;;;EAAA;ACAA;;;EAAA;AAAA;;;EAAA;ACEA;;;EAAA;AAKA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ACyBJ;ADvBI;EAEI,sBAAA;ACwBR;ADrBI;EACI,wBAAA;ACuBR;;ADnBA;;EAEI,SAAA;EACA,iBAAA;ACsBJ;;ADnBA;EACI,WAAA;ACsBJ;;ADnBA;EACI,WAAA;ACsBJ;;ADnBA;;;;;EAKI,SAAA;ACsBJ;;ADnBA;;;;;;;;;;;;EAYI,oBAAA;ACsBJ;;ADnBA;EACI,OAAA;ACsBJ;ADpBI;EACI,WAAA;ACsBR;ADnBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ACoBR;;ADhBA;EACI,WAAA;ACmBJ;;ADhBA;EACI,YAAA;ACmBJ;;ACxGA;;;EAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AD0GJ;;ACvGA;;;;;;;;;;;;EAYI,cAAA;AD0GJ;;ACvGA;;EAEI,gBAAA;AD0GJ;;ACvGA;;EAEI,YAAA;AD0GJ;ACxGI;;;;EAEI,aAAA;AD4GR;;ACxGA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AD2GJ;;ACxGA;EACI,yBAAA;EACA,iBAAA;AD2GJ;;ACxGA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AD2GJ;;ACxGA;;EAEI,sBAAA;AD2GJ;;ACxGA;EACI,kBAAA;AD2GJ;;ACvGI;EACI,aAAA;AD0GR;;ACtGA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ADyGJ;;ACpGQ;EACI,gBAAA;EACA,cAAA;ADuGZ;ACnGY;EACI,cAAA;ADqGhB;;AAxQA;EACI,sBAAA;EACA,0BAAA;AA2QJ;AAzQI;EACI,WAAA;EACA,iCLYgB;EKXhB,sBAAA;EACA,gBAAA;EACA,WAAA;AA2QR;AAzQQ;EACI,mBAAA;EACA,SAAA;AA2QZ;AAtQQ;EACI,aAAA;AAwQZ;AAvQY;EFFR,eEG0B;EFF1B,iBEEgC;EFDhC,gBECsC;EFAtC,iBAJqE;EEKzD,+BEtBS;EFuBT,cLCY;EKAZ,kBAAA;AA4QhB;AA1QY;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,cLNY;AKkR5B;AAxQQ;EACI,YAAA;EACA,iBAAA;EACA,sBAAA;EFnBR,eEoBsB;EFnBtB,iBEmB4B;EFlB5B,gBEkBkC;EFjBlC,iBAJqE;EEsB7D,+BErCa;EFsCb,cLhBgB;AK6R5B;AA3QY;EFxBR,eEyB0B;EFxB1B,iBEwBgC;EFvBhC,gBEuBsC;EFtBtC,iBAJqE;EE2BzD,+BE1CS;EF2CT,cLrBY;AKqS5B;AA7QY;EF9BR,eE+B0B;EF9B1B,iBE8BgC;EF7BhC,gBE6BsC;EF5BtC,iBAJqE;EEiCzD,cLjCI;AKmTpB;AA9QQ;EACI,iBAAA;EACA,aAAA;AAgRZ;AA/QY;EFvCR,eEwC0B;EFvC1B,iBEuCgC;EFtChC,gBEsCsC;EFrCtC,iBAJqE;EE0CzD,+BEzDS;EF0DT,cLpCY;AKwT5B;;AA9QA;EACI,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAiRJ;AA/QI;EACI,WAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cL3Dc;EK4Dd,aAAA;EACA,kBAAA;EACA,eAAA;AAiRR;AA/QQ;EAEI,yBAAA;EACA,wBAAA;AAgRZ;AA7QQ;EACI,yBAAA;EACA,cAAA;AA+QZ;AA3QI;EFhFA,eEiFkB;EFhFlB,iBEgFwB;EF/ExB,gBE+E8B;EF9E9B,iBAJqE;EEmFjE,0CAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAgRR;AA7QI;EACI,mBAAA;AA+QR;;AA1QA;EACI;IACI,yBAAA;EA6QN;EA3QM;IACI,gBAAA;IACA,WAAA;EA6QV;EA1QM;IACI,WAAA;EA4QV;EAzQc;IACI,gBAAA;IACA,MAAA;EA2QlB;EAxQc;IFhHZ,eEiH8B;IFhH9B,iBEgHoC;IF/GpC,gBE+G0C;IF9G1C,iBAJqE;IEmHrD,kBAAA;EA6QlB;EAzQU;IACI,WAAA;IACA,cAAA;IACA,sBAAA;IFzHZ,eE0H0B;IFzH1B,iBEyHgC;IFxHhC,gBEwHsC;IFvHtC,iBAJqE;EEyYvE;EA5Qc;IF5HZ,eE6H8B;IF5H9B,iBE4HoC;IF3HpC,gBE2H0C;IF1H1C,iBAJqE;EE+YvE;EA9Qc;IFhIZ,eEiI8B;IFhI9B,iBEgIoC;IF/HpC,gBE+H0C;IF9H1C,iBAJqE;EEqZvE;EA/QU;IACI,eAAA;IACA,cAAA;EAiRd;EAhRc;IACI,UAAA;IFzIhB,eE0I8B;IFzI9B,iBEyIoC;IFxIpC,gBEwI0C;IFvI1C,iBAJqE;EEgavE;EAnRc;IACI,iBAAA;EAqRlB;EAhRM;IACI,gBAAA;EAkRV;AACF;AA9QA;EACI,sBAAA;EACA,0BAAA;AAgRJ;AA9QI;EACI,WAAA;EACA,iCL9JgB;EK+JhB,sBAAA;EACA,sBAAA;EACA,wBAAA;AAgRR;AA7QI;EACI,UAAA;EACA,WAAA;AA+QR;AA7QQ;EACI,aAAA;AA+QZ;AA9QY;EF1KR,eE2K0B;EF1K1B,iBE0KgC;EFzKhC,gBEyKsC;EFxKtC,iBAJqE;EE6KzD,+BE9LS;EF+LT,cLvKY;EKwKZ,kBAAA;AAmRhB;AAjRY;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,cL9KY;EK+KZ,cAAA;EACA,eAAA;AAmRhB;AA/QQ;EACI,sBAAA;EF3LR,eE4LsB;EF3LtB,iBE2L4B;EF1L5B,gBE0LkC;EFzLlC,iBAJqE;EE8L7D,+BE7Ma;EF8Mb,cLxLgB;AK4c5B;AAlRY;EFhMR,eEiM0B;EFhM1B,iBEgMgC;EF/LhC,gBE+LsC;EF9LtC,iBAJqE;EEmMzD,+BElNS;EFmNT,cL7LY;AKod5B;AAnRQ;EFvMJ,eEwMsB;EFvMtB,iBEuM4B;EFtM5B,gBEsMkC;EFrMlC,iBAJqE;EE0M7D,+BEzNa;EF0Nb,cLpMgB;EKqMhB,gBAAA;AAwRZ;AAtRY;EF7MR,eE8M0B;EF7M1B,iBE6MgC;EF5MhC,gBE4MsC;EF3MtC,iBAJqE;EEgNzD,+BE/NS;EFgOT,cL1MY;AKqe5B;AAxRY;EFnNR,eEoN0B;EFnN1B,iBEmNgC;EFlNhC,gBEkNsC;EFjNtC,iBAJqE;EEsNzD,cLtNI;AKmfpB;AAzRQ;EACI,aAAA;AA2RZ;AA1RY;EF3NR,eE4N0B;EF3N1B,iBE2NgC;EF1NhC,gBE0NsC;EFzNtC,iBAJqE;EE8NzD,+BE7OS;EF8OT,cLxNY;AKuf5B;AA3RQ;EACI,iBAAA;EACA,iBAAA;AA6RZ;AAzRI;EACI,YAAA;AA2RR;AAzRQ;EACI,gCE/Pc;EJmBtB,eE6OsB;EF5OtB,iBE4O4B;EF3O5B,gBE2OkC;EF1OlC,iBE0OuC;EFxNvC,cHvBkB;EGwBlB,gBAAA;EEyNQ,eAAA;AA+RZ;AFtfI;EACI,cALyC;AE6fjD;AFrfI;EACI,cH/Bc;EGgCd,0BAAA;EACA,mBAAA;AEufR;;AAlSA;EACI;IACI,sBAAA;EAqSN;EAlSU;IACI,WAAA;EAoSd;EAjSU;IACI,cAAA;IACA,WAAA;EAmSd;EAjSc;IACI,eAAA;EAmSlB;EA/RU;IACI,aAAA;EAiSd;EAhSc;IFxQZ,eEyQ8B;IFxQ9B,iBEwQoC;IFvQpC,gBEuQ0C;IFtQ1C,iBAJqE;IE2QrD,kBAAA;EAqSlB;EAnSc;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,cL1QQ;IK2QR,cAAA;IACA,eAAA;EAqSlB;EAjSU;IACI,qBAAA;EAmSd;EAhSU;IACI,aAAA;EAkSd;EAjSc;IF5RZ,eE6R8B;IF5R9B,iBE4RoC;IF3RpC,gBE2R0C;IF1R1C,iBAJqE;EEokBvE;EAlSU;IFjSR,eEkS0B;IFjS1B,iBEiSgC;IFhShC,gBEgSsC;IF/RtC,iBAJqE;EE0kBvE;EArSc;IFpSZ,eEqS8B;IFpS9B,iBEoSoC;IFnSpC,gBEmS0C;IFlS1C,iBAJqE;IEuSrD,cLvSA;EKilBlB;EArSM;IACI,YAAA;IACA,gBAAA;EAuSV;EArSU;IF/SR,eEgT0B;IF/S1B,iBE+SgC;IF9ShC,gBE8SsC;IF7StC,iBE6S2C;EA0S7C;AACF","sourcesContent":["/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.vehicle-registration {\r\n    padding: 32px 0 0 36px;\r\n    --link: $aulani-link-color;\r\n\r\n    .border-section {\r\n        height: 1px;\r\n        border-bottom: $primary-aulani-border;\r\n        background-image: none;\r\n        margin: 32px 0 0;\r\n        width: 100%;\r\n\r\n        &.hide-broder {\r\n            border-bottom: none;\r\n            height: 0;\r\n        }\r\n    }\r\n\r\n    .left-section {\r\n        .vehicle-heading {\r\n            display: flex;\r\n            h3 {\r\n                @include font(24px, 32px, 600);\r\n                font-family: $inspiretwdc-heavy-font;\r\n                color: $aulani-primary-text-color;\r\n                padding-left: 12px;\r\n            }\r\n            img.ground-car {\r\n                width: 27px;\r\n                height: 24px;\r\n                font-size: 21px;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            width: 600px;\r\n            margin-left: 40px;\r\n            padding: 16px 0 16px 0;\r\n            @include font(18px, 27px, 400);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: $aulani-primary-text-color;\r\n\r\n            span.text {\r\n                @include font(18px, 27px, 400);\r\n                font-family: $inspiretwdc-roman-font;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n\r\n            a {\r\n                @include font(18px, 27px, 600);\r\n                color: $aulani-link-color;\r\n            }\r\n        }\r\n\r\n        .counter {\r\n            margin-left: 40px;\r\n            display: flex;\r\n            .que-text {\r\n                @include font(18px, 27px, 400);\r\n                font-family: $inspiretwdc-roman-font;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.number-stepper {\r\n    display: flex;\r\n    width: 145px;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-left: 28px;\r\n    margin-top: -10px;\r\n\r\n    .number-stepper-button {\r\n        width: 32px;\r\n        height: 32px;\r\n        gap: 0px;\r\n        opacity: 0px;\r\n        border: 1px solid $primary-aulani-link;\r\n        border-radius: 50%;\r\n        color: $primary-aulani-link;\r\n        outline: none;\r\n        font-size: x-large;\r\n        cursor: pointer;\r\n\r\n        &:hover,\r\n        &:active {\r\n            border: 1px solid $primary-aulani-link;\r\n            color: 1px solid $primary-aulani-link;\r\n        }\r\n\r\n        &:disabled {\r\n            border: 1px solid #C2BFB8;\r\n            color: #C2BFB8;\r\n        }\r\n    }\r\n\r\n    .count-number {\r\n        @include font(40px, 45px, 300);\r\n        font-family: $inspiretwdc-roman-font !important;\r\n        color: $aulani-primary-text-color !important;\r\n        min-width: 80px;\r\n        text-align: center;\r\n    }\r\n\r\n    .negative {\r\n        padding-bottom: 5px;\r\n    }\r\n}\r\n\r\n// Mobile devices\r\n@media only screen and (max-width: 767px) {\r\n    .vehicle-registration  {\r\n        padding: 32px 20px 0 20px;\r\n\r\n        .border-section {\r\n            margin: 32px 0 0;\r\n            width: 100%;\r\n        }\r\n\r\n        .left-section {\r\n            width: 100%;\r\n\r\n            .vehicle-heading {\r\n                img.ground-car {\r\n                    margin-left: 0px;\r\n                    top: 0;\r\n                }\r\n    \r\n                h3 {\r\n                    @include font(18px, 27px, 600);\r\n                    padding-left: 12px\r\n                }\r\n            }\r\n    \r\n            .content {\r\n                width: 100%;\r\n                margin-left: 0;\r\n                padding: 12px 0 24px 0;\r\n                @include font(16px, 24px, 400);\r\n\r\n                span.text {\r\n                    @include font(16px, 24px, 400);\r\n                }\r\n    \r\n                a {\r\n                    @include font(16px, 24px, 600);\r\n                }\r\n            }\r\n\r\n            .counter {\r\n                padding-left: 0;\r\n                margin-left: 0;\r\n                .que-text {\r\n                    width: 50%;\r\n                    @include font(16px, 24px, 400);\r\n                }\r\n                .number-stepper {\r\n                    margin-left: 21px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            margin-top: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n.vehicle-registration-mod-flow {\r\n    padding: 32px 0 0 40px;\r\n    --link: $aulani-link-color;\r\n\r\n    .border-section {\r\n        height: 1px;\r\n        border-bottom: $primary-aulani-border;\r\n        background-image: none;\r\n        margin: 30px 0 0 -30px;\r\n        width: calc(100% + 30px);\r\n    }\r\n\r\n    .left-section {\r\n        width: 70%;\r\n        float: left;\r\n       \r\n        .vehicle-heading {\r\n            display: flex;\r\n            h3 {\r\n                @include font(20px, 30px, 600);\r\n                font-family: $inspiretwdc-heavy-font;\r\n                color: $aulani-primary-text-color;\r\n                padding-left: 12px;\r\n            }\r\n            img.ground-car {\r\n                width: 24px;\r\n                height: 24px;\r\n                font-size: 21px;\r\n                color: $aulani-primary-text-color;\r\n                margin-left: 0;\r\n                margin-top: 3px;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            padding: 10px 0 0 40px;\r\n            @include font(18px, 27px, 400);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: $aulani-primary-text-color;\r\n\r\n            p.text {\r\n                @include font(18px, 27px, 400);\r\n                font-family: $inspiretwdc-roman-font;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n        }\r\n\r\n        .learn-more-info {\r\n            @include font(18px, 27px, 400);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: $aulani-primary-text-color;\r\n            margin-top: 10px;\r\n\r\n            span {\r\n                @include font(18px, 27px, 400);\r\n                font-family: $inspiretwdc-roman-font;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n\r\n            a {\r\n                @include font(18px, 27px, 600);\r\n                color: $aulani-link-color;\r\n            }\r\n        }\r\n\r\n        .counter {\r\n            display: flex;\r\n            .que-text {\r\n                @include font(18px, 27px, 400);\r\n                font-family: $inspiretwdc-roman-font;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n        }\r\n\r\n        .number-stepper {\r\n            margin-left: 24px;\r\n            margin-top: -10px;\r\n        }\r\n    }\r\n\r\n    .right-section {\r\n        float: right;\r\n\r\n        .section-edit {\r\n            font-family: $inspiretwdc-medium-font;\r\n            @include font(18px, 27px, 600, 0);\r\n            @include btn-link($papaya-greybg-color);\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .vehicle-registration-mod-flow {\r\n        padding: 16px 0 0 35px;\r\n\r\n        .left-section {\r\n            &.counter-section {\r\n                width: 100%;\r\n            }\r\n\r\n            .number-stepper {\r\n                margin-left: 0;\r\n                width: auto;\r\n\r\n                .count-number {\r\n                    min-width: 40px;\r\n                }\r\n            }\r\n\r\n            .vehicle-heading {\r\n                display: flex;\r\n                h3 {\r\n                    @include font(16px, 24px, 600);\r\n                    padding-left: 17px;\r\n                }\r\n                img.ground-car {\r\n                    width: 20px;\r\n                    height: 20px;\r\n                    font-size: 21px;\r\n                    color: $aulani-primary-text-color;\r\n                    margin-left: 0;\r\n                    margin-top: 1px;\r\n                }\r\n            }\r\n\r\n            .content {\r\n                padding: 8px 0 0 40px;\r\n            }\r\n\r\n            .counter {\r\n                display: flex;\r\n                .que-text {\r\n                    @include font(16px, 24px, 400);\r\n                }\r\n            }\r\n\r\n            .learn-more-info {\r\n                @include font(16px, 24px, 400);\r\n    \r\n                a {\r\n                    @include font(16px, 24px, 600);\r\n                    color: $aulani-link-color;\r\n                }\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            float: right;\r\n            margin-top: 30px;\r\n    \r\n            .section-edit {\r\n                @include font(16px, 24px, 600, 0);\r\n            }\r\n        }\r\n    }\r\n}","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
